import React, { Children, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AboutMe from './AboutMe';
import Bio from './Bio';
import Personality from './Personality';
import Hobbies from './Hobbies';
import MyIdealPartner from './MyIdealPartner';
import MyAlbum from './MyAlbum';
import NavBarUser from '../NavBarUser';
import './MultiStepForm.css';

export default function MultiStepForm() {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    // About me page state values
    marital_status: '',
    relationship_goal: '',
    ethnicity: '',
    ethnicityOthers: '',
    dob: {
      day: '',
      month: '',
      year: '',
    },
    education: '',
    educationOthers: '',
    diet: '',
    dietOthers: '',
    gender: '',
    mobile_number: '',
    alternate_email: '',
    username: '',
    about_me: '',
    // Bio page state values
    body_type: '',
    profession: '',
    children: '',
    age_of_children: '',
    eye_color: '',
    hair_color: '',
    smoking_habit: '',
    drinking_habit: '',
    religion: '', // USER_PROFILE
    religion_others: '', // USER_PROFILE
    describe_religion: '',
    height: '',
    weight: '',
  });

  const FormTitles = [
    'About Me',
    'Bio',
    'Personality',
    'Hobbies',
    'My Ideal Partner',
    'My Album',
  ];

  const maxSteps = FormTitles.length - 1; // page 1 = 0 index so -1

  const PageDisplay = () => {
    if (step === 0) {
      return (
        <AboutMe
          nextStep={nextStep}
          prevStep={prevStep}
          maxSteps={maxSteps}
          step={step}
          formData={formData}
          setFormData={setFormData}
        />
      );
    }
    if (step === 1) {
      return (
        <Bio
          nextStep={nextStep}
          prevStep={prevStep}
          maxSteps={maxSteps}
          step={step}
          formData={formData}
          setFormData={setFormData}
        />
      );
    }
    if (step === 2) {
      return (
        <Personality
          nextStep={nextStep}
          prevStep={prevStep}
          maxSteps={maxSteps}
          step={step}
          formData={formData}
          setFormData={setFormData}
        />
      );
    }
    if (step === 3) {
      return (
        <Hobbies
          nextStep={nextStep}
          prevStep={prevStep}
          maxSteps={maxSteps}
          step={step}
          formData={formData}
          setFormData={setFormData}
        />
      );
    }
    if (step === 4) {
      return (
        <MyIdealPartner
          nextStep={nextStep}
          prevStep={prevStep}
          maxSteps={maxSteps}
          step={step}
          formData={formData}
          setFormData={setFormData}
        />
      );
    }
    if (step === 5) {
      return (
        <MyAlbum
          nextStep={nextStep}
          prevStep={prevStep}
          maxSteps={maxSteps}
          step={step}
          formData={formData}
          setFormData={setFormData}
        />
      );
    }
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const percentStyle = (step) => {
    // Calculate percentage based on current step and total steps
    const percentage = ((step + 1) / FormTitles.length) * 100;
    return { width: `${percentage}%` };
  };

  // check if jwt token present after register or login to fill multi step form
  const navigate = useNavigate();
  useEffect(() => {
    var token = localStorage.getItem('token');
    if (!token) {
      console.log('No token found. Redirecting to register page');
      navigate('/register', { replace: true });
    }
  }, []);

  return (
    <>
      <NavBarUser />
      <div className='form'>
        <div className='progressbar'>
          <div style={percentStyle(step)}></div>
        </div>
        <div className='form-container'>
          <div className='header'>
            <h1>{FormTitles[step]}</h1>
          </div>
          <div className='body'>{PageDisplay()}</div>
        </div>
      </div>
    </>
  );
}
